import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { IIconComponent, ITooltipDirective } from "@front/m19-ui";

@Component({
  selector: "app-limit-warning",
  templateUrl: "./limit-warning.component.html",
  imports: [ITooltipDirective, IIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LimitWarningComponent {
  @Input({ required: true })
  current!: number;
  @Input({ required: true })
  limit!: number;
  @Input()
  message = "";

  label?: string;
}
